import { useQueryCache, useMutation } from "react-query";
import putInspectionsPublicOnSiteContactInfo, {
  IUpdateOnSiteContactInfo,
} from "../../../queries/inspections/public/putInspectionsPublicOnSiteContactInfo";
import useNetworkHeaders from "../../../permits/components/InspectionsCard/useNetworkHeaders";
import { getInspectionQueryKey } from "../useInspection";
import { PublicInspectionQueryKey } from "./usePublicInspection";

interface IUseInspectionsPublicOnSiteContactMutation {
  id: number | string;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}
export default function useInspectionsPublicOnSiteContactMutation({
  id,
  onSuccess = () => {},
  onError = () => {},
}: IUseInspectionsPublicOnSiteContactMutation) {
  const queryCache = useQueryCache();
  const networkHeaders = useNetworkHeaders();

  const [onSiteContactMutation, onSiteContactMutationState] = useMutation(
    putInspectionsPublicOnSiteContactInfo(networkHeaders, Number(id)),
    {
      onSuccess: () => {
        onSuccess();
        const inspectionQueryKey = getInspectionQueryKey(id);
        queryCache.invalidateQueries(inspectionQueryKey);
        const publicInspectionQueryKey = PublicInspectionQueryKey(id);
        queryCache.invalidateQueries(publicInspectionQueryKey);
      },
      onError: (error: unknown) => {
        onError(error);
      },
    },
  );

  return {
    updateOnSiteContact: (data: IUpdateOnSiteContactInfo) => {
      onSiteContactMutation(data);
    },
    isLoading: onSiteContactMutationState.isLoading,
  };
}
